
import { httpClient } from '../_helpers';
export const productService = {
    getAll
};
function getAll() {
    return httpClient().get(`api/products`);
}


// WEBPACK FOOTER //
// ./src/_services/product.service.js